export default {
    intro: '초성, 뜻, 예문 등의 단서를 보고<br />어떤 단어인지 추리해보세요!',
    word: '단어',
    meaning: '뜻',
    example: '예',
    resources: '자료',
    teacherFooter: {
        left: '왼쪽 문항에서 단어를 선택해 주세요.',
    },
    table: {
        question: '문제',
        emptyMessage: '내용이 없어요.',
    },
};
